
export { GGUSection } from "/codebuild/output/src190029547/src/packages/shared-components/src/campaign/GGUSection.tsx"